"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunnerStatusMonitor = void 0;
const React = __importStar(require("react"));
const messaging_common_1 = require("@guided-methods/messaging-common");
require("./styles/status.scss");
const host_context_1 = require("./host-context");
const models_1 = require("../models");
const react_bootstrap_1 = require("react-bootstrap");
const PreConditionsStatus_1 = require("./PreConditionsStatus");
const SpinnerWithCaption_1 = require("./SpinnerWithCaption");
const react_intl_1 = require("react-intl");
const SlideIn_1 = __importDefault(require("./SlideIn"));
const tds_1 = require("@guided-methods/tds");
const UserDecisionController = ({ allowProceed, allowRetry, requiresConfirmation, abortHandler, retryHandler, continuationHandler }) => {
    const [userHasConfirmed, setUserHasConfirmed] = React.useState(false);
    const confirmationHandler = ({ target: { value } }) => {
        setUserHasConfirmed(!userHasConfirmed);
    };
    const intl = (0, react_intl_1.useIntl)();
    return (React.createElement("div", { className: 'flex flex-col' },
        React.createElement("div", { className: 'my-1 justify-center ' }, requiresConfirmation && (React.createElement(react_bootstrap_1.Form, null,
            React.createElement(react_bootstrap_1.Form.Check, { id: 'checkbox-iHaveUnderstood', type: "checkbox", className: "p-3", "data-testid": "checkbox-iHaveUnderstood", checked: userHasConfirmed, onChange: confirmationHandler, label: intl.formatMessage({ id: "RunnerStatusMonitor.Caption.IHaveUnderstood", defaultMessage: "I understand there are risks in continuing without all preconditions" }) })))),
        React.createElement("div", { className: 'flex flex-row justify-center mb-6' },
            React.createElement(tds_1.Button, { onClick: abortHandler, className: "p-1 m-1", testId: "btn-abort", type: 'secondary', size: 'large', fullBleed: true },
                React.createElement(react_intl_1.FormattedMessage, { id: 'RunnerStatusMonitor.Caption.Abort', defaultMessage: 'Abort' })),
            React.createElement(tds_1.Button, { onClick: retryHandler, className: "p-1 m-1", disabled: !allowRetry, testId: "btn-retry", type: 'primary', size: 'large', fullBleed: true },
                React.createElement(react_intl_1.FormattedMessage, { id: 'RunnerStatusMonitor.Caption.Retry', defaultMessage: 'Retry' })),
            React.createElement(tds_1.Button, { onClick: continuationHandler, className: "p-1 m-1", disabled: !allowProceed || !userHasConfirmed, testId: "btn-continue", type: 'danger', size: 'large', fullBleed: true },
                React.createElement(react_intl_1.FormattedMessage, { id: 'RunnerStatusMonitor.Caption.Continue', defaultMessage: 'Continue' })))));
};
const PreconditionsCheckResult = ({ context, conditions, conditionResults, resolvingFailure, retryHandler, abortHandler, continuationHandler }) => {
    const { router, rootChannelId, messageService } = React.useContext(host_context_1.HostContext);
    return (React.createElement(SlideIn_1.default, null,
        React.createElement(react_bootstrap_1.Card, { className: "border-0 min-vh-100" },
            React.createElement(react_bootstrap_1.Card.Header, { className: "header" },
                React.createElement(react_intl_1.FormattedMessage, { "autotest-id": "title-preconditions", id: 'RunnerStatusMonitor.Caption.Preconditions', defaultMessage: 'Preconditions' })),
            React.createElement(react_bootstrap_1.Card.Body, { className: "main" }, messageService && rootChannelId &&
                React.createElement(PreConditionsStatus_1.PreconditionsStatus, { router: router, messageService: messageService, conditions: conditions ?? [], context: context, conditionResults: conditionResults, resolvingFailure: resolvingFailure, rootChannelId: rootChannelId })),
            React.createElement(react_bootstrap_1.Card.Footer, { className: "footer" },
                React.createElement(UserDecisionController, { allowRetry: true, allowProceed: true, requiresConfirmation: true, abortHandler: abortHandler, continuationHandler: continuationHandler, retryHandler: retryHandler })))));
};
const RunnerStatusMonitor = ({ children, strict }) => {
    const [runnerStatus, setRunnerStatus] = React.useState();
    const [showPreconditionsView, setShowPreconditionsView] = React.useState(false);
    const [showSpinner, setShowSpinner] = React.useState(false);
    const [latestExecutionStatusChange, setLatestExecutionStatusChange] = React.useState(undefined);
    const showSpinnerWithDelay = (enable = true, timeout = 1000) => {
        setShowSpinner(enable);
    };
    const intl = (0, react_intl_1.useIntl)();
    const { router, channels, rootChannelId, messageService, logger } = React.useContext(host_context_1.HostContext);
    const abortHandler = () => {
        if (latestExecutionStatusChange?.responseChannel !== undefined) {
            setShowPreconditionsView(false);
            const { responseChannel, requestId, preConditionsStatus, context } = latestExecutionStatusChange;
            let errorMessage = thereWasAnErrorEvaluatingPreconditions(latestExecutionStatusChange) ||
                thereArePreConditionsThatDidNotPass(latestExecutionStatusChange)
                ? "Failed to evaluate preconditions. Abort request"
                : "Failed to evaluate preconditions due to unknown error. Abort request";
            try {
                setLatestExecutionStatusChange(undefined);
                messageService?.send(responseChannel, messaging_common_1.GuideMessageType.Data, context ?? {}, {
                    type: 'Abort',
                    requestId: requestId ?? "",
                    conditions: preConditionsStatus?.conditions ?? [],
                    errorMessage
                });
            }
            catch (error) {
                logger?.error({
                    message: `[PreconditionsAbort] Error sending abort message for requestId ${requestId}: ${error instanceof Error ? error.message : 'Unknown error'}`,
                    mode: messaging_common_1.LogMode.Framework,
                });
                setLatestExecutionStatusChange(undefined);
            }
        }
        else {
            logger?.warn({
                message: '[PreconditionsAbort] Abort handler called but no response channel available',
                mode: messaging_common_1.LogMode.Framework,
            });
        }
    };
    const retryHandler = () => {
        if (latestExecutionStatusChange?.responseChannel !== undefined) {
            const { responseChannel, requestId, preConditionsStatus, context } = latestExecutionStatusChange;
            let errorMessage = thereWasAnErrorEvaluatingPreconditions(latestExecutionStatusChange) ||
                thereArePreConditionsThatDidNotPass(latestExecutionStatusChange)
                ? "Failed to evaluate preconditions. Retry request."
                : "Failed to evaluate preconditions due to unknown error. Retry request";
            try {
                setLatestExecutionStatusChange(undefined);
                messageService?.send(responseChannel, messaging_common_1.GuideMessageType.Data, context ?? {}, {
                    type: 'Retry',
                    requestId: requestId ?? "",
                    conditions: preConditionsStatus?.conditions ?? [],
                    errorMessage
                });
            }
            catch (error) {
                logger?.error({
                    message: `[PreconditionsRetry] Error sending retry message for requestId ${requestId}: ${error instanceof Error ? error.message : 'Unknown error'}`,
                    mode: messaging_common_1.LogMode.Framework,
                });
                setLatestExecutionStatusChange(undefined);
            }
        }
        else {
            logger?.warn({
                message: '[PreconditionsRetry] Retry handler called but no response channel available',
                mode: messaging_common_1.LogMode.Framework,
            });
        }
    };
    const continuationHandler = () => {
        if (latestExecutionStatusChange?.responseChannel !== undefined) {
            const { responseChannel, requestId, preConditionsStatus, context } = latestExecutionStatusChange;
            try {
                setLatestExecutionStatusChange(undefined);
                messageService?.send(responseChannel, messaging_common_1.GuideMessageType.Data, context ?? {}, {
                    type: 'ForceProceed',
                    requestId: requestId ?? "",
                    conditions: preConditionsStatus?.conditions ?? [],
                    errorMessage: "Failed to evaluate preconditions. User opted for forced start"
                });
            }
            catch (error) {
                logger?.error({
                    message: `[PreconditionsForceProceed] Error sending force proceed message for requestId ${requestId}: ${error instanceof Error ? error.message : 'Unknown error'}`,
                    mode: messaging_common_1.LogMode.Framework,
                });
                setLatestExecutionStatusChange(undefined);
            }
        }
        else {
            logger?.warn({
                message: '[PreconditionsForceProceed] Force proceed handler called but no response channel available',
                mode: messaging_common_1.LogMode.Framework,
            });
        }
    };
    React.useEffect(() => {
        if (!channels)
            return;
        const controller = router?.subscribe(channels.browserRunnerStatusChannel, async (m, _, r) => {
            if (m.type !== messaging_common_1.GuideMessageType.Data) {
                return await r.next();
            }
            logger?.debug({
                message: `[RunnerStatusMonitor] Received browser runner status event: ${m.data.type}`,
                mode: messaging_common_1.LogMode.Framework,
            });
            switch (m.data.type) {
                case models_1.BrowserRunnerStatusMessageType.SignalRConnected:
                    setRunnerStatus({
                        status: m.data.type,
                    });
                    break;
                case models_1.BrowserRunnerStatusMessageType.IframeHostReady:
                    setRunnerStatus({
                        status: m.data.type,
                    });
                    break;
                case models_1.BrowserRunnerStatusMessageType.GuideStarting:
                    setLatestExecutionStatusChange({
                        ...latestExecutionStatusChange,
                        requestId: undefined,
                        context: m.context,
                        status: m.data.type,
                    });
                    break;
                case models_1.BrowserRunnerStatusMessageType.GuideCompleted:
                    setLatestExecutionStatusChange(undefined);
                    break;
                case models_1.BrowserRunnerStatusMessageType.Error:
                    {
                        setLatestExecutionStatusChange({
                            ...latestExecutionStatusChange,
                            requestId: undefined,
                            context: undefined,
                            preConditionsStatus: undefined,
                            status: m.data.type,
                        });
                    }
                    break;
                case models_1.BrowserRunnerStatusMessageType.GuidePreconditionsCheckStarted:
                    {
                        setLatestExecutionStatusChange({
                            status: m.data.type,
                            context: m.context,
                            requestId: m.data.requestId,
                            preConditionsStatus: {
                                conditions: m.data.conditions,
                                conditionResults: undefined,
                                resolvingFailure: undefined,
                            },
                        });
                    }
                    break;
                case models_1.BrowserRunnerStatusMessageType.GuidePreconditionsCheckPassed:
                    {
                        setLatestExecutionStatusChange({
                            status: m.data.type,
                            context: m.context,
                            requestId: m.data.requestId,
                            preConditionsStatus: {
                                conditions: m.data.conditions,
                                conditionResults: undefined,
                                resolvingFailure: false,
                            },
                        });
                    }
                    break;
                case models_1.BrowserRunnerStatusMessageType.GuidePreconditionsCheckFailed:
                    {
                        setLatestExecutionStatusChange({
                            responseChannel: m.data.responseChannel,
                            status: m.data.type,
                            requestId: m.data.requestId,
                            context: m.context,
                            preConditionsStatus: {
                                conditions: m.data.conditions,
                                conditionResults: m.data?.conditionResults,
                                resolvingFailure: m.data.resolvingFailure,
                            },
                        });
                    }
                    break;
                default:
                    setLatestExecutionStatusChange(undefined);
            }
            return await r.next();
        });
        return () => {
            if (channels.browserRunnerStatusChannel && controller)
                router?.unsubscribe(channels.browserRunnerStatusChannel, controller);
        };
    }, [router, runnerStatus]);
    React.useEffect(() => {
        if (!latestExecutionStatusChange)
            return;
        const showSpinner = thereIsPendingPreconditionsEvaluation(latestExecutionStatusChange);
        const showResults = thereArePreConditionsThatDidNotPass(latestExecutionStatusChange) ||
            thereWasAnErrorEvaluatingPreconditions(latestExecutionStatusChange);
        setShowPreconditionsView(showResults);
        showSpinnerWithDelay(showSpinner);
    }, [latestExecutionStatusChange]);
    return (React.createElement("div", { className: "min-w-100" },
        showPreconditionsView && latestExecutionStatusChange ? (React.createElement(PreconditionsCheckResult, { abortHandler: abortHandler, continuationHandler: continuationHandler, retryHandler: retryHandler, conditionResults: latestExecutionStatusChange?.preConditionsStatus?.conditionResults ?? [], conditions: latestExecutionStatusChange?.preConditionsStatus?.conditions ?? [], context: latestExecutionStatusChange?.context ?? {}, resolvingFailure: thereWasAnErrorEvaluatingPreconditions(latestExecutionStatusChange) })) : (React.createElement(React.Fragment, null)),
        showSpinner && !(showPreconditionsView && latestExecutionStatusChange !== undefined) ? (React.createElement(SpinnerWithCaption_1.SpinnerWithCaption, { caption: intl.formatMessage({ id: 'RunnerStatusMonitor.Caption.Initializing', defaultMessage: 'Initializing...' }) })) : (React.createElement(React.Fragment, null)),
        React.createElement("div", { hidden: (showSpinner || (showPreconditionsView && latestExecutionStatusChange !== undefined)) }, children)));
};
exports.RunnerStatusMonitor = RunnerStatusMonitor;
const thereIsPendingPreconditionsEvaluation = (latestExecutionStatusChange) => latestExecutionStatusChange?.preConditionsStatus !== undefined &&
    latestExecutionStatusChange?.status === models_1.BrowserRunnerStatusMessageType.GuidePreconditionsCheckStarted;
const thereWasAnErrorEvaluatingPreconditions = (latestExecutionStatusChange) => latestExecutionStatusChange?.preConditionsStatus !== undefined &&
    latestExecutionStatusChange?.status === models_1.BrowserRunnerStatusMessageType.GuidePreconditionsCheckFailed &&
    latestExecutionStatusChange?.preConditionsStatus?.resolvingFailure === true;
const thereArePreConditionsThatDidNotPass = (latestExecutionStatusChange) => latestExecutionStatusChange?.preConditionsStatus !== undefined &&
    latestExecutionStatusChange?.status === models_1.BrowserRunnerStatusMessageType.GuidePreconditionsCheckFailed &&
    latestExecutionStatusChange?.preConditionsStatus?.resolvingFailure === false;
